import { useField } from 'formik';
import { useState } from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import { IInputField, Input, InputContainer, InputLabel, InputWrapper } from './FormField';

export const HideableTextWithOutErrorMsgFormField: React.FC<IInputField> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  // apiKey,
  ...props
}) => {
  const [field] = useField(props);
  const [showKey, setShowKey] = useState(false);

  const handleToggle = () => {
    setShowKey(!showKey);
  };

  return (
    <>
      <InputWrapper className={className}>
        <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
        <InputContainer>
          <Input {...field} {...props} type={showKey ? 'text' : 'password'} />
          <VisibilityToggleIconsArea>
            {showKey ? (
              <EyeOutlined onClick={handleToggle} />
            ) : (
              <EyeInvisibleOutlined onClick={handleToggle} />
            )}
          </VisibilityToggleIconsArea>
        </InputContainer>
      </InputWrapper>
    </>
  );
};

const VisibilityToggleIconsArea = styled.div`
  display: flex;
  margin-right: 1rem;
  margin-left: auto;

  & > * > svg {
    color: #867c79;
  }
`;
